














































import Vue, { PropType } from 'vue'
import { IRoom } from '@/models/IRoom'
import { IStudent } from '@/models/IStudent'
import { Actions } from '@/shared/Actions'
import StudentInRoomForm from './StudentInRoomForm.vue'
import StudentFilledForm from '@/components/in-room-registration/StudentFilledForm.vue'

export default Vue.extend({
  name: 'RoomStudentsForm',
  components: { StudentInRoomForm, StudentFilledForm },
  props: {
    room: {
      type: Object as PropType<IRoom>,
      required: true
    }
  },
  computed: {
    isReservationRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.RESERVE_ROOM][this.room._id]
    },
    canRegisterStudents(): boolean {
      return this.room.reservedMeta === this.$store.state.user.meta
    },
    restPlaces(): number {
      return this.room.size - this.room.students.length
    }
  },
  methods: {
    registerStudent(student: IStudent) {
      this.$store.dispatch(Actions.REGISTER_STUDENT, {
        roomId: this.room._id,
        student
      })
    },
    removeStudent(student: IStudent, removedBy: string) {
      this.$confirm(
        `Jesteś pewnien, że chcesz usunąć uczestnika ${student.name} ${student.surname}?`,
        'Potwierdzenie',
        {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          type: 'error'
        }
      ).then(() => {
        this.$store.dispatch(Actions.REMOVE_STUDENT, {
          roomId: this.room._id,
          student,
          removedBy
        })
      })
    },
    reserveRoom() {
      this.$store.dispatch(Actions.RESERVE_ROOM, {
        roomId: this.room._id
      })
    }
  }
})
